import React from 'react';
import { ChargingReportFilters } from './models';

interface ChargingReportsSearchBarProps {
    filters: ChargingReportFilters;
    onFilter: (filter: ChargingReportFilters) => void;
}

export const ChargingReportsSearchBar = (props: ChargingReportsSearchBarProps) => {

    const onInputChange = (inputEvent: any) => {
        props.onFilter({
            search: inputEvent.target.value
        });
    };

    return (
        <div className="electricity-invoices__search-bar bar-position">
            <h2 className="text-light">
                Laadimisraportid
            </h2>
            <div className="card mb-5 shadow">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap">
                        <input
                            placeholder="Jaama ID / nimi"
                            className='search-bar__input p-2'
                            onChange={onInputChange}
                            value={props.filters.search || ''}
                        />
                    </div>    
                </div>
            </div>
        </div>
    )
}